module.exports = __webpack_public_path__ + "assets/img/season3-b8484950.png";